import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
function realistichd(imagePath, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      31: {
        inputs: {
          vae_name: 'FLUX.1-vae.sft'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      34: {
        inputs: {
          upscale_method: 'lanczos',
          megapixels: 8,
          image: [
            '134',
            0
          ]
        },
        class_type: 'ImageScaleToTotalPixels',
        _meta: {
          title: 'Scale Image to Total Pixels'
        }
      },
      36: {
        inputs: {
          tile_width: [
            '111',
            0
          ],
          tile_height: [
            '111',
            1
          ],
          image: [
            '34',
            0
          ]
        },
        class_type: 'TTP_Image_Tile_Batch',
        _meta: {
          title: '🪐TTP_Image_Tile_Batch'
        }
      },
      42: {
        inputs: {
          text: 'high quality, highly detailed, 8k wallpaper,',
          clip: [
            '78',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      67: {
        inputs: {
          noise: [
            '70',
            0
          ],
          guider: [
            '72',
            0
          ],
          sampler: [
            '68',
            0
          ],
          sigmas: [
            '69',
            0
          ],
          latent_image: [
            '129',
            0
          ]
        },
        class_type: 'SamplerCustomAdvanced',
        _meta: {
          title: 'SamplerCustomAdvanced'
        }
      },
      68: {
        inputs: {
          sampler_name: 'euler'
        },
        class_type: 'KSamplerSelect',
        _meta: {
          title: 'KSamplerSelect'
        }
      },
      69: {
        inputs: {
          scheduler: 'simple',
          steps: 4,
          denoise: 0.3,
          model: [
            '77',
            0
          ]
        },
        class_type: 'BasicScheduler',
        _meta: {
          title: 'BasicScheduler'
        }
      },
      70: {
        inputs: {
          noise_seed: seed
        },
        class_type: 'RandomNoise',
        _meta: {
          title: 'RandomNoise'
        }
      },
      72: {
        inputs: {
          model: [
            '77',
            0
          ],
          conditioning: [
            '73',
            0
          ]
        },
        class_type: 'BasicGuider',
        _meta: {
          title: 'BasicGuider'
        }
      },
      73: {
        inputs: {
          guidance: 3.5,
          conditioning: [
            '42',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      77: {
        inputs: {
          unet_name: 'flux1-dev-unet-fp8-e4m3fn.safetensors',
          weight_dtype: 'fp8_e4m3fn'
        },
        class_type: 'UNETLoader',
        _meta: {
          title: 'Load Diffusion Model'
        }
      },
      78: {
        inputs: {
          clip_name1: 't5xxl_fp8_e4m3fn.safetensors',
          clip_name2: 'clip_l.safetensors',
          type: 'flux'
        },
        class_type: 'DualCLIPLoader',
        _meta: {
          title: 'DualCLIPLoader'
        }
      },
      111: {
        inputs: {
          width_factor: 2,
          height_factor: 3,
          overlap_rate: 0.05,
          image: [
            '34',
            0
          ]
        },
        class_type: 'TTP_Tile_image_size',
        _meta: {
          title: '🪐TTP_Tile_image_size'
        }
      },
      127: {
        inputs: {
          padding: 128,
          tiles: [
            '247',
            0
          ],
          positions: [
            '36',
            1
          ],
          original_size: [
            '36',
            2
          ],
          grid_size: [
            '36',
            3
          ]
        },
        class_type: 'TTP_Image_Assy',
        _meta: {
          title: '🪐TTP_Image_Assy'
        }
      },
      129: {
        inputs: {
          pixels: [
            '36',
            0
          ],
          vae: [
            '31',
            0
          ]
        },
        class_type: 'VAEEncode',
        _meta: {
          title: 'VAE Encode'
        }
      },
      133: {
        inputs: {
          model_name: '4x-UltraSharp.pth'
        },
        class_type: 'UpscaleModelLoader',
        _meta: {
          title: 'Load Upscale Model'
        }
      },
      134: {
        inputs: {
          upscale_model: [
            '133',
            0
          ],
          image: [
            '244',
            0
          ]
        },
        class_type: 'ImageUpscaleWithModel',
        _meta: {
          title: 'Upscale Image (using Model)'
        }
      },
      244: {
        inputs: {
          width: 1024,
          height: 1024,
          upscale_method: 'nearest-exact',
          keep_proportion: true,
          divisible_by: 2,
          crop: 'disabled',
          image: [
            '252',
            0
          ]
        },
        class_type: 'ImageResizeKJ',
        _meta: {
          title: 'Resize Image'
        }
      },
      247: {
        inputs: {
          samples: [
            '67',
            0
          ],
          vae: [
            '31',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      250: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '127',
            0
          ]
        },
        class_type: 'OSSUploadNode',
        _meta: {
          title: '保存图片到oss'
        }
      },
      252: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'LoadImageFromURL',
        _meta: {
          title: '从url加载图片'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
        return null
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 250 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  realistichd
}
